/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('./../src/jobiqo/config/app');
const R = require('ramda');

// Set true for app localized.
const defaultLocale = 'de';
const locales = ['de'];

// The format map provides an ability to separate locales from the format of dates.
// An important note is that messages is the language that will be sent to the backend as the language to get data
// LocaleFormat is what will be configured in react-intl for number and date formats.
// The messages (texts in the website) will be based on messages information, so if the user visits in this case "en"
// he would see number formatted in "en" (but it could be configured for de or pt).
// Each of the keys in the mapping will be sent to nextJs as the allowed locale.
// const formatMap = {
//   [defaultLocale]: {
//     messages: defaultLocale,
//     localeFormat: defaultRegion,
//   },
// };
const formatMap = {};

module.exports = R.mergeDeepRight(jobiqoAppConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    TURBOPACK_BUILD: true,
    LOCALES: locales,
    DEFAULT_LOCALE: defaultLocale,
    FORMAT_MAP: formatMap,
    SITENAME: 'RUHR24JOBS',
    SITE_DESCRIPTION:
      'RUHR24JOBS.de ist das reichweitenstarke Online-Jobportal für das Ruhrgebiet und NRW. Jeden Tag bringen wir regionale Arbeitgeber und Arbeitnehmer erfolgreich zusammen.',
    FRONTENDS: {
      default: 'ruhr24',
    },
    SOCIAL_LINKS: {
      facebook: 'https://www.facebook.com/RUHR24JOBS',
      linkedin: 'https://www.linkedin.com/company/10959711',
      xing: 'https://www.xing.com/pages/ruhr24gmbh-co-kg',
      instagram: 'https://www.instagram.com/RUHR24JOBS',
      tiktok: 'https://www.tiktok.com/@ruhr24jobs',
    },
    GA4_MEASUREMENT_IDS: ['G-CR2F4GPGEK'],
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      location: { lat: 51.1657, lng: 10.4515 },
      radius: 500,
    },
    CMP_ID: '88bac7593e99',
    CMP_PROVIDER: 'ConsentManager',
    CMP_PREF_BUTTON: true,
    NEWSLETTER_FEATURE_ACTIVE: true,
    GTM_CONTAINER_ID: 'GTM-P5RHPV9',
    GOOGLE_GEOSUGGEST_CONSENT: true,
    LINKEDIN_OAUTH_FEATURE_ACTIVE: true,
    GOOGLE_OAUTH_FEATURE_ACTIVE: true,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: true,
    PATH_TRANSLATIONS_ACTIVE: true,
    SUBSCRIPTIONS_FEATURE_ACTIVE: true,
    JOBIQO_AIR_TRACKING_ACTIVE: true,
    GOOGLE_MEASUREMENT_API_ENABLED: true,
    THEME: {
      colors: {
        primary: '#ee730b',
      },
    },
    PRIVACY_LINK: '/datenschutz',
    NON_LANDING_PAGE_PATHS: [
      '/jobs',
      '/job',
      '/resume',
      '/organization',
      '/user',
      '/contact',
      '/karriere-ratgeber',
      '/fuer-arbeitgeber',
    ],
  },
});
